import { get, isEqual } from 'lodash';
import React from 'react';

import ChoiceButton from '../ChoiceButton';

class ChoicesField extends React.Component {
  constructor(props) {
    super(props);
    const { path, uuid } = this.props;

    this.path = path || [uuid];
  }

  componentDidMount() {
    const { doc } = this.props;
    doc.on('op', this.onOp);
  }

  componentWillUnmount() {
    const { doc } = this.props;
    doc.removeListener('op', this.onOp);
  }

  onOp = (op, source) => {
    if (
      op.some((operation) =>
        isEqual(operation.p.slice(0, this.path.length), this.path)
      )
    ) {
      this.forceUpdate();
    }
  };

  render() {
    const {
      readOnlyWorksheet,
      currentUser,
      multiple,
      choices,
      data: rawData,
      doc,
      uniqueName,
      setChangedToNow = () => {},
    } = this.props;

    // We have some instances in our production database where `multiple` was stored as a Boolean, and others
    // where `multiple` was stored as a string.
    const allowsMultipleResponses = multiple === 'true' || multiple === true;
    const data = rawData || get(doc.data, this.path);
    const onChange = (value) => (evt) => {
      const {
        target: { checked },
      } = evt;
      const p = [...this.path, allowsMultipleResponses ? value : 0];
      const op = [{ p, ld: null, li: checked ? value : null }];
      doc.submitOp(op);

      if (!currentUser.noPresence) {
        doc.submitPresence({
          p: this.path,
          u: currentUser.userId,
        });
      }

      setChangedToNow();
    };

    return choices.map(({ label }, index) => {
      const type = allowsMultipleResponses ? 'checkbox' : 'radio';

      // Multiple responses are stored in `data` in the format [0, null, 2] to denote index 0 and 2
      // are selected. Note in this example there may be more than 3 options to select, but all the
      // options after index 2 are undefined and thus not selected.
      const isChecked = allowsMultipleResponses
        ? data[index] === index
        : index === data[0];
      return (
        <ChoiceButton
          key={String(index)}
          id={`${this.path}-${index}`}
          type={type}
          name={uniqueName}
          value={index}
          onChange={!readOnlyWorksheet ? onChange(index) : null}
          checked={isChecked}
          disabled={readOnlyWorksheet}
          readOnly={readOnlyWorksheet}
        >
          {label}
        </ChoiceButton>
      );
    });
  }
}

export default ChoicesField;
